import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { removeSystemFieldNamePrefix } from '../../utils/Utilities';
import { RequiredMarker } from '../RequiredMarker';

export const CustomFieldLabel = ({
  fieldName,
  isSystem = false,
  fontStyle = 'italic',
  required = false,
  ...props
}: {
  fieldName: string;
  isSystem: boolean;
  fontStyle?: string;
  required?: boolean;
}) => {
  const { t } = useTranslation('translation');

  if (isSystem) {
    return (
      <Tooltip title={t(($) => $.ideaManagement.general.systemFieldToolTip)} arrow>
        <span
          className="fs-exclude"
          data-dd-action-name="FIM 3 System Custom Field - tooltip label redacted"
          style={{ fontStyle: fontStyle || 'italic' }}
          {...props}
        >
          {removeSystemFieldNamePrefix(fieldName)}
          {required && <RequiredMarker />}
        </span>
      </Tooltip>
    );
  }

  return (
    <span
      className="fs-exclude"
      data-dd-action-name="FIM 3 Custom Field - label redacted"
      data-testid={`fim3-custom-field-label-${fieldName}`}
      {...props}
    >
      {fieldName}
      {required && <RequiredMarker />}
    </span>
  );
};
